import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const alertType = ["info", "success", "warning", "error"];
export const alertProps = buildProps({
  closable: {
    type: Boolean,
    default: false,
  },
  border: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "info",
    values: alertType,
  },
} as const);

export type xAlertProps = ExtractPropTypes<typeof alertProps>;
